import { Global } from "./base/Global";
export * from "./Components/LoginComponent";
export * from "./Components/PasswordRecoveryComponent";
export * from './Base/VueProvider';

$(document as any).ready(() => {
    const global = new Global();
    global.init();
});